import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toggleChat } from 'apps/promo/actions/chatAction';
import { BackToTopButton } from 'apps/promo/components/common/back-to-top-button/BackToTopButton';
import { Breadcrumbs } from 'apps/promo/components/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { Date } from 'apps/promo/components/common/date/Date';
import { LightButton } from 'apps/promo/components/common/fromAuth/LightButton/LightButton';
import { LightFixedBottomPanel } from 'apps/promo/components/common/fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { TextComponent } from 'apps/promo/components/common/sections/styles';
import ZendeskHelpSearch from 'apps/promo/components/help/ZendeskHelpSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix, getYYYYMMDDDate } from 'apps/promo/helpers/utils';

const ZendeskHelpArticlePage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const category = props.category;
    const section = props.sections?.find((s) => s.id === sectionIdNumber);
    const article = props.article;

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;
    const urlParams = useGetQueryParams();

    const breadcrumbs = [
        { name: 'Paysend', url: getHelpCenterUrl(url, urlParams) },
        { name: category?.name, url: getHelpCenterUrl(`${url}/category/${category?.id}`, urlParams) },
        { name: section?.name, url: getHelpCenterUrl(`${url}/category/${category?.id}/section/${section?.id}`, urlParams) },
        { name: article?.title },
    ];

    const date = getYYYYMMDDDate(article?.created_at);

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                {!article?.label_names?.includes(urlParams.popularLabel) && <Breadcrumbs breadcrumbsItems={breadcrumbs} />}
                <HeadingSection title={article?.title} titleTag={'h1'} />
                <PromoRow indent="adaptive-32-48-64">
                    <Date date={date} />
                </PromoRow>
                <PromoRow indent="64px">
                    <TextComponent linksHighlited>
                        <PromoDangerouslyHtml color="gray80" dangerouslyHtml={article?.body} />
                    </TextComponent>
                </PromoRow>
                <BackToTopButton caption={props.backToTop} />
            </ColoredSectionContainer>
            {props.showZendeskChat && (
                <LightFixedBottomPanel pressedAboveCookieButton>
                    <LightButton raised={true} caption={props.chatButton} onClick={() => props.toggleChat(true)} />
                </LightFixedBottomPanel>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    chatButton: extra?.strapiApi?.chat_btn,
    backToTop: extra?.strapiApi?.back_to_top_btn,
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    article: extra?.zendeskHelpData?.article,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
    showZendeskChat: extra?.noAuthFooter?.showZendeskChat,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpArticlePage));
